import qs from 'qs';
import axiosClient from './axiosClient';

/**
 * ログインデータ
 */
export interface LoginIndexPost {
  /**
   * ユーザー名（メールアドレス）
   */
  username?: string;

  /**
   * パスワード
   */
  password?: string;
}
/**
 * パスワードリマインダー
 */
export interface PasswordReminderIndexPost {
  /**
   * メールアドレス
   */
  email?: string;
}

/**
 * パスワードリセット
 */
export interface ResetPasswordIndexPost {
  /**
   * メールアドレス
   */
  email?: string;

  /**
   * 確認コード
   */
  confirmation_code?: string;

  /**
   * 新しいパスワード
   */
  password?: string;

  /**
   * 新しいパスワード（確認）
   */
  password_confirmation?: string;
}

/**
 * refresh
 */
export interface RefreshIndexPost {
  /**
   * refreshToken
   */
  refreshToken?: string | null;
}

/**
 * delete
 */
export interface DeleteIndexPost {
  /**
   * email
   */
  email?: string;

  /**
   * パスワード
   */
  password?: string;
}
/**
 * パスワード変更
 */
export interface ChangePasswordIndexPost {
  /**
   * メールアドレス
   */
  email?: string;

  /**
   * 現在パスワード
   */
  password?: string;

  /**
   * 新しいパスワード
   */
  new_password?: string;

  /**
   * 新しいパスワード（確認）
   */
  new_password_confirmation?: string;
}
/**
 * メールアドレス変更
 */
export interface ChangeEmailIndexPost {
  /**
   * メールアドレス
   */
  email?: string;

  /**
   * パスワード
   */
  password?: string;
}
export interface AuthenticationResponsePost {
  /**
   * AccessToken
   */
  AccessToken?: string;

  /**
   * ExpiresIn
   */
  ExpiresIn?: number;

  /**
   * TokenType
   */
  TokenType?: string;

  /**
   * RefreshToken
   */
  RefreshToken?: string;

  /**
   * IdToken
   */
  IdToken?: string;
}

export interface AuthenticationResponsePostWrapper {
  /**
   * status
   */
  status?: string;

  /**
   * response
   */
  response?: AuthenticationResponsePost;

  /**
   * error
   */
  error?: any;
}

/**
 * 認証サービス
 */
export default class AuthenticationService {
  /**
   * ログイン
   * API => login(LoginIndexPost): AuthenticationResponsePostWrapper
   * @param input
   */
  public static async login(input: LoginIndexPost): Promise<AuthenticationResponsePostWrapper> {
    const url = '/user/login';
    const data = new FormData();
    data.append('username', input.username ? input.username : '');
    data.append('password', input.password ? input.password : '');
    try {
      const response = await axiosClient.post<AuthenticationResponsePostWrapper>(url, data);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }

  /**
   * token リフレッシュ
   * API => refresh(RefreshIndexPost): AuthenticationResponsePostWrapper
   * @param input
   */
  public static async refresh(input: RefreshIndexPost): Promise<AuthenticationResponsePostWrapper> {
    const url = '/user/refresh';
    const data = new FormData();
    data.append('token', input.refreshToken ? input.refreshToken : '');
    try {
      const response = await axiosClient.post<AuthenticationResponsePostWrapper>(url, data);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }

  /**
   * パスワード変更
   * API => changePassword(ChangePasswordIndexPost): any
   * @param input
   */
  public static async changePassword(input: ChangePasswordIndexPost):
   Promise<any> {
    const url = '/user/password/change';
    const data = new FormData();
    data.append('email', input.email ? input.email : '');
    data.append('password', input.password ? input.password : '');
    data.append('new_password', input.new_password ? input.new_password : '');
    data.append('new_password_confirmation', input.new_password_confirmation ? input.new_password_confirmation : '');
    try {
      const response = await axiosClient.post<any>(url, data);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }

  /**
   * メールアドレス変更
   * API => changeEmail(ChangeEmailIndexPost): any
   * @param input
   */
  public static async changeEmail(input: ChangeEmailIndexPost):
   Promise<any> {
    const url = '/user/change/email';
    const data = new FormData();
    data.append('email', input.email ? input.email : '');
    data.append('password', input.password ? input.password : '');
    data.append('password_confirmation', input.password ? input.password : '');
    try {
      const response = await axiosClient.post<any>(url, data);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }

  /**
   * 退会
   * API => delete(DeleteIndexPost): AuthenticationResponsePostWrapper
   * @param input
   */
  public static async delete(input: DeleteIndexPost): Promise<any> {
    const query = qs.stringify(
      {
        email: input.email,
        password: input.password,
      },
      {
        arrayFormat: 'brackets',
      },
    );
    const url = `/user/delete?${query}`;
    try {
      const res = await axiosClient.get(url);
      return res.data;
    } catch (err: any) {
      return err.response.data;
    }
  }

  /**
   * パスワードリマインダー
   * API => passwordReminder(PasswordReminderIndexPost): any
   * @param input
   */
  public static async passwordReminder(input: PasswordReminderIndexPost):
    Promise<any> {
    const url = '/user/forgot';
    const data = new FormData();
    data.append('email', input.email ? input.email : '');
    try {
      const response = await axiosClient.post<any>(url, data);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }

  /**
   * パスワードリセット
   * @param input
   * @returns
   */
  public static async resetPassword(input: ResetPasswordIndexPost):
   Promise<any> {
    const url = '/user/forgot/store';
    const data = new FormData();
    data.append('email', input.email ? input.email : '');
    data.append('confirmation_code', input.confirmation_code ? input.confirmation_code : '');
    data.append('password', input.password ? input.password : '');
    data.append('password_confirmation', input.password_confirmation ? input.password_confirmation : '');
    try {
      const response = await axiosClient.post<any>(url, data);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }
}
